import * as actions from "../actions/actions";
import { connect } from "react-redux";

import React from "react";

import IconList from "./nounproject-iconlist";

class BestCollection extends React.Component {
    static defaultProps = {
        maxIcons: 36
    };
    static propTypes = {
        maxIcons: React.PropTypes.number.isRequired
    };

    componentDidMount() {
        this.props.fetchBestCollectionIcons();
    }

    constructor(props) {
        super(props);

        this.state = {
            icons: undefined
        };
    }

    render() {
        return (
            <div className="best-collection container row">
                <style>{`
                    .keep-browsing {
                        margin: 0 auto;
                    }
                    @media (min-width: 768px) {
                        .keep-browsing {
                            margin: 10px 0;
                            flex-direction: row-reverse;
                        }
                    }
                `}</style>
                <IconList
                    maxIcons={this.props.maxIcons}
                    iconSize={"42"}
                    icons={this.props.icons}
                />
                <div className="keep-browsing container row">
                    <a
                        className="text-link"
                        href="/browse/"
                        title="Keep Browsing Best Icons"
                    >
                        Keep Browsing
                    </a>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let icons = [];

    if (state.icons.featured_icons) {
        state.icons.featured_icons.keys.forEach(iconId => {
            let icon = state.icons.featured_icons[iconId];
            // update icon permalink for iconlist
            icon.permalink = `/browse/`;
            icons.push(icon);
        });
    }

    return { icons };
}

module.exports = connect(mapStateToProps, {
    fetchBestCollectionIcons: actions.fetchBestCollectionIcons
})(BestCollection);
